module.exports = __webpack_public_path__ + "static/media/CreateTagIcon.c984cd77.svg";